
import orderBoxNew from '@/components/OrderBox/OrderBoxNew'
import UserInfoBox from '@/components/UserInfoBox'

export default {
    components: {
        orderBoxNew,
        UserInfoBox
    },
    data() {
        return {}
    },
    beforeRouteLeave(to, from, next) {
        if (to.path !== '/account/sellerDetails') {
            let _page = {
                page: 1,
                pageSize: 10
            }
            this.$store.commit('SET_MY_GOODS_PAGE', _page)
        }
        next()
    },
    created() {}
}
